import { defineMessages } from 'react-intl';

export default defineMessages({
  selectFile: {
    id: 'app.containers.FileInput.selectFile',
    defaultMessage: 'Select file...',
  },
});
